import React, { lazy, Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import Calendar from "./pages/CalendarPage/ResourceTimeLine";
import AllRestaurantDayWiseReport from "./pages/Shops/Shop/Reports/AllRestaurantDayWiseReport";
import HourlyItemSalesReport from "./pages/Shops/Shop/Reports/HourlyItemSalesReport";
import CategorySummaryReport from "./pages/Shops/Shop/Reports/CategorySummaryReport";
import OrderWiseSalesSummaryReport from "./pages/Shops/Shop/Reports/OrderWiseSalesSummaryReport";
import Reports from "./pages/Shops/Shop/Reports/Reports";
import RestaurantDayWiseBalanceSummaryReoprt from "./pages/Shops/Shop/Reports/RestaurantDayWiseBalanceSummaryReoprt";
import ReportSchedule from "./pages/RevenueManagement/ReportScheduler/ReportSchedule";
import IshaEreceiptPreview from "./pages/Folios/IshaEreceiptPreview";
import KitchenConfig from "./pages/Stock/KitchenConfig";
import PurchaseOrder from "./pages/Stock/PurchaseOrder";
import WarehouseStockReport from "./pages/Stock/Reports/WarehouseStockReport";
import KitchenStockReport from "./pages/Stock/Reports/KitchenStockReport";
import PurchaseOrderReport from "./pages/Stock/Reports/PurchaseOrderReport";
import ClosingStockWarehouseReport from "./pages/Stock/Reports/ClosingStockWarehouseReport";
import ClosingStockKitchenReport from "./pages/Stock/Reports/ClosingStockKitchenReport";
import WarehouseCumulativeReport from "./pages/Stock/Reports/WarehouseCumulativeReport";
import StockDashboard from "./pages/Stock/StockDashboard";
import WareHouseConsumptionReport from "./pages/Stock/Reports/WareHouseConsumptionReport";
import FoodCostingReport from "./pages/Stock/Reports/FoodCostingReport";
import HousekeepingRawMaterial from "./pages/Stock/Housekeeping/HousekeepingRawMaterial";
import AddHousekeepingMaterial from "./pages/Stock/Housekeeping/AddHousekeepingMaterial";
import PaymentsDashboard from "./pages/PaymentConfig/PaymentsDashboard";
import NightAuditDashboard from "./pages/NightAudits/NightAuditDashboard";
import DashboardRecommendation from "./pages/DashboardRecommendation.js";
import DaywiseItemSummaryReport from "./pages/Shops/Shop/Reports/DaywiseItemSummaryReport";
import { connect } from "react-redux";
import GroupTimeline from "./pages/CalendarPage/GroupTimeline.js";
import GroupBeConfig from "./pages/BookingEngine/GroupBeConfig.js";
import OTAPaymentReport from "./pages/Reports/PaymentsReports/OTAPaymentReport.js";
import InvoiceConfig from "./pages/Shops/Shop/Configuration/Components/InvoiceConfig.js";
import ArchivedFolioReport from "./pages/Reports/AdditionalReports/FolioReport/ArchivedFolioReport.js";
import OutletDashboard from "./pages/Shops/OutletDashboard.jsx";
import SingleRentalSpaceDashboard from "./pages/Shops/RentalSpace/SingleRentalSpaceDashboard.jsx";
import AgridRentals from "./pages/Shops/RentalSpace/reports/AgridRentals.jsx";

// Kot modification report
const KotModificationReport = lazy(() =>
  import("./pages/Shops/Shop/Reports/KotModificationReport")
);

// Kot report
const KotReport = lazy(() => import("./pages/Shops/Shop/Reports/KotReport"));
const ChannelMapping = lazy(() =>
  import("./pages/ChannelMapping/ChannelMapping")
);

const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const Report = lazy(() => import("./pages/Reports/Report"));
const AgGridTable = lazy(() =>
  import("./pages/Reports/MasterReport/AgGridTable")
);
const DayUseReport = lazy(() =>
  import("./pages/Reports/DayUseReports/DayUseReport")
);
const RoomBookingReport = lazy(() =>
  import("./pages/Reports/RoomBookingsReport/AgGridTable")
);

const IshaEnquiryPage = lazy(() =>
  import("../_metronic/layout/components/header/header-menu/IshaEnquiryPage")
);
const IshaRefundPage = lazy(() =>
  import("../_metronic/layout/components/header/header-menu/IshaRefundPage")
);
const CustomizedReport = lazy(() =>
  import("./pages/Reports/MasterReport/CustomizedReport")
);
const SalesReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/SalesReport/SalesReport")
);
const PaymentsReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/PaymentsReport/PaymentsReport")
);
const CounterReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/CounterReport/CounterReport")
);
const ServicesReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/ServicesReport/ServicesReport")
);
const InventoryReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/InventoryReport/InventoryReport")
);
const RoomRevenueReport = lazy(() =>
  import(
    "./pages/Reports/ManagerialReports/RoomRevenueReport/RoomRevenueReport"
  )
);
const RoomRevenueReportSource = lazy(() =>
  import("./pages/Reports/AdditionalReports/RoomRevenueReportSource")
);
const TaxReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/TaxReport/TaxReport")
);

const GSTReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/TaxReport/GSTReport")
);

const RoomBookingsReport = lazy(() =>
  import(
    "./pages/Reports/FrontDeskReports/RoomBookingsReport/RoomBookingsReport"
  )
);
const OccupancyReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/OccupancyReport/OccupancyReport")
);
const BookingEngineReport = lazy(() =>
  import(
    "./pages/Reports/FrontDeskReports/BookingEngineReport/BookingEngineReport"
  )
);
const CustomerReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/CustomerReport/CustomerReport")
);
const ChannelManagerReport = lazy(() =>
  import(
    "./pages/Reports/FrontDeskReports/ChannelManagerReport/ChannelManagerReport"
  )
);
const FlexCollectReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/FlexCollectReport/FlexCollectReport")
);
const TravelAgentReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/TravelAgentReport/TravelAgentReport")
);
const POSReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/POSReport/POSReport")
);
const POSDetailReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/POSDetailReport/POSDetailReport")
);
const FlashManagerReport = lazy(() =>
  import(
    "./pages/Reports/ManagerialReports/FlashManagerReport/FlashManagerReport"
  )
);
const AuditReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/AuditReport/AuditReport")
);

const FolioReport = lazy(() =>
  import("./pages/Reports/AdditionalReports/FolioReport/FolioReport")
);

const UserLogsReport = lazy(() => import("./pages/Reports/UserLogsReport"));
const ShiftReport = lazy(() => import("./pages/Reports/ShiftReport"));

const Shops = lazy(() => import("./pages/Shops/Shops"));

const AddNewShopAdditionalDetails = lazy(() =>
  import("./pages/Shops/AddNewShopAdditionalDetails")
);
const ShopConfiguration = lazy(() => import("./pages/Shops/ShopConfiguration"));
const StartOrder = lazy(() => import("./pages/Shops/StartOrder"));
const InventoryCalendar = lazy(() =>
  import("./pages/InventoryCalendar/Inventory")
);

const HouseKeeping = lazy(() => import("./pages/HouseKeeping/HouseKeeping"));
const CartInvoice = lazy(() => import("./pages/Shops/CartInvoice"));
const AdvancedPortfolioWrapper = lazy(() =>
  import("./pages/Folios/Advanced Portfolio/AdvancedPortfolioWrapper")
);
const PropertyDetails = lazy(() =>
  import("./pages/PropertyConfiguration/PropertyDetails/PropertyDetails")
);
const POSViewOrders = lazy(() => import("./pages/Shops/POSViewOrders"));
const CreatedOrder = lazy(() => import("./pages/Shops/CreatedOrder"));

const PropertyDashboard = lazy(() =>
  import("./pages/PropertyConfiguration/PropertyDetails/PropertyDashboard")
);

const RentalDashboard = lazy(() =>
  import("./pages/Shops/RentalSpace/RentalDashboard")
);
const RentalFolio = lazy(() =>
  import("./pages/Shops/RentalSpace/SpaceModules/RentalFolio")
);

const AccountInfo = lazy(() => import("./pages/AccountInfo/AccountInfo"));

const AccountSetting = lazy(() =>
  import("./pages/AccountSettings/AccountSetting")
);

const BookingDashboard = lazy(() =>
  import("./pages/BookingDashboard/BookingDashboard")
);

const RevenueDashboard = lazy(() =>
  import("./pages/RevenueManagement/Dashboard/RevenueDashBoard")
);
const InventoryStockReport = lazy(() =>
  import("./pages/Stock/Reports/InventoryStockReport")
);

const AllShops = lazy(() => import("./pages/Shops/AllShops/AllShops"));
const AddNewShop = lazy(() => import("./pages/Shops/AddNewShop/AddShop"));
const Shop = lazy(() => import("./pages/Shops/Shop/ShopWrapper"));
const TableView = lazy(() =>
  import("./pages/Shops/Shop/PlaceOrders/Components/TableView")
);
const OutletConfiguration = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/OutletDetails")
);
const ShopDashboard = lazy(() =>
  import("./pages/Shops/Shop/Dashboard/DashboardPage")
);
const PlaceOrderPage = lazy(() =>
  import("./pages/Shops/Shop/PlaceOrders/PlaceOrderPage")
);
const OutletPage = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/OutletConfiguration")
);
const MenuItems = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/MenuItems")
);
const ConfigureItems = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/ConfigureItems")
);
const EditItems = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/EditItems")
);
const ProductCategories = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/ProductCategory")
);
const ConfigureCategory = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/ConfigureCategory")
);
const EditCategory = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/EditCategory")
);
const Staff = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/Staff")
);
const EditStaff = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/EditStaff")
);
const Discount = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/Discount")
);
const ConfigureDiscount = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/ConfigureDiscount")
);
const EditDiscount = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/EditDiscount")
);
const Table = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/Table")
);
const ConfigureTable = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/ConfigureTable")
);
const ConfigureStaff = lazy(() =>
  import("./pages/Shops/Shop/Configuration/Components/ConfigureStaff")
);
const ViewOrders = lazy(() =>
  import("./pages/Shops/Shop/ViewOrders/ViewOrders")
);

// Folios
const Folio = lazy(() => import("./pages/Folios/Folios"));

// Room Folio
const RoomFolio = lazy(() => import("./pages/RoomFolio/RoomFolio"));

const DirectBilling = lazy(() => import("./pages/CTA/CTA"));

const ExpanseDrawer = lazy(() =>
  import("./pages/SelfBasicConfig/ExpanseDrawer")
);

const ExpenseManagerDashBoard = lazy(() =>
  import("./pages/SelfBasicConfig/Expense/ExpenseManagerDashBoard")
);

const ReputationManagementDashBoard = lazy(() =>
  import("./pages/ReputationManagement/ReputationManagementDashBoard")
);

// Reports
const ReportWrapper = lazy(() => import("./pages/Reports/ReportWrapper"));
const ArrivalsReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/ArrivalsReport")
);
const DepartureReports = lazy(() =>
  import("./pages/Reports/FrontDeskReports/DepartureReports")
);
const InhouseReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/InhouseReport")
);
const NewBookingsReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/NewBookingsReport")
);
const NoShowReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/NoShowReport")
);
const OnholdReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/OnholdReport")
);

const DaywiseAllOutletSales = lazy(() =>
  import("./pages/Reports/POS Reports/DaywiseAllOutletsSales")
);
const AllOutletsHourlyItemsSalesSummary = lazy(() =>
  import("./pages/Reports/POS Reports/AllOutletsHourlyItemsSalesSummary")
);
const AllOutletsItemWiseCategory = lazy(() =>
  import("./pages/Reports/POS Reports/AllOutletsItemwiseCategory")
);
const AllOutletsOrderSales = lazy(() =>
  import("./pages/Reports/POS Reports/AllOutletsOrderSales")
);
const BookingNotesReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/BookingNotesReport")
);
const CustomerNotesReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/CustomerNotesReport")
);
const ShopwiseRevReport = lazy(() =>
  import("./pages/Reports/POS Reports/ShopwiseRevReport")
);

const SelfCheckinReport = lazy(() =>
  import("./pages/Reports/PropertyReports/SelfCheckinReport")
);

const RoomUpgradeReport = lazy(() =>
  import("./pages/Reports/PropertyReports/RoomUpgradeReport")
);

const EarlyCheckinReport = lazy(() =>
  import("./pages/Reports/PropertyReports/EarlyCheckinReport")
);

const LateCheckoutReport = lazy(() =>
  import("./pages/Reports/PropertyReports/LateCheckoutReport")
);

const DoNotRentReport = lazy(() =>
  import("./pages/Reports/CustomerReports/DoNotRentReport")
);

const ExpenseReport = lazy(() =>
  import("./pages/Reports/ExpenseReports/ExpenseReport")
);

const RoomRevByOTAReport = lazy(() =>
  import("./pages/Reports/ChannelManagerReports/RoomRevByOTA")
);

const RefundsReport = lazy(() =>
  import("./pages/Reports/PaymentsReports/RefundsReport")
);

const TransfersReport = lazy(() =>
  import("./pages/Reports/PaymentsReports/TransfersReport")
);

const PaymentsUserReport = lazy(() =>
  import("./pages/Reports/PaymentsReports/PaymentsUserReport")
);

const PaymentsReportByPaymentType = lazy(() =>
  import("./pages/Reports/PaymentsReports/PaymentsReportByPaymentType")
);

const CounterReportByPaymentType = lazy(() =>
  import("./pages/Reports/PaymentsReports/CounterReportByPaymentType")
);

const ServiceSalesReport = lazy(() =>
  import("./pages/Reports/ManagerialReports/ServiceSalesReport")
);

const DirectBillingARBalanceReport = lazy(() =>
  import("./pages/Reports/DirectBillingReports/DirectBillingArBalanceReport")
);

const DirectBillingArAgingReport = lazy(() =>
  import("./pages/Reports/DirectBillingReports/DirectBillingArAgingReport")
);

const BarPricingReport = lazy(() =>
  import("./pages/Reports/PropertyReports/BarPricingReport")
);

const CommissionReport = lazy(() =>
  import("./pages/Reports/PaymentsReports/CommissionReport")
);

const MealPlanCountReport = lazy(() =>
  import("./pages/Reports/FrontDeskReports/MealPlanCountReport")
);

// Inventory and Stock Management
const RawMaterialSupplier = lazy(() =>
  import("./pages/Stock/RawMaterialSupplier")
);
const WarehouseRawMaterial = lazy(() =>
  import("./pages/Stock/WarehouseRawMaterial")
);
const KitchenRawMaterial = lazy(() =>
  import("./pages/Stock/KitchenRawMaterial")
);
const ClosingStock = lazy(() => import("./pages/Stock/ClosingStock"));
const RawMaterialWastage = lazy(() =>
  import("./pages/Stock/RawMaterialWastage")
);
const ProductRecipe = lazy(() => import("./pages/Stock/ProductRecipe"));

// Chat
const Chat = lazy(() => import("./pages/Chat/Inbox"));

const Invoice = lazy(() => import("./pages/Invoice/components/Index"));

// TallyLogsReport
const TallyLogsReport = lazy(() => import("./pages/Reports/TallyLogsReport"));
const ReportsDashboard = lazy(() =>
  import("./pages/Shops/RentalSpace/reports/ReportsDashboard")
);

const BlackAndWhiteFolio = lazy(() =>
  import("./pages/BlackAndWhiteFolio/index.js")
);

const BasePage = ({ selectedLanguage, data }) => {
  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");

  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  let isFolioV3Enabled = false;
  try {
    if (
      data?.accessControl?.user_feature_map?.FolioV3 &&
      JSON.parse(data.accessControl.user_feature_map.FolioV3).read === "YES"
    ) {
      isFolioV3Enabled = true;
    }
  } catch (e) {
    console.error("Could not parse FolioV3 permission:", e);
  }

  let isSmartFolioEnabled = false;
  try {
    if (
      (data?.accessControl?.user_feature_map?.SmartFolio &&
        JSON.parse(data.accessControl.user_feature_map.SmartFolio).read ===
          "YES") ||
      hotelId === "12921"
    ) {
      isSmartFolioEnabled = true;
    }
  } catch (e) {
    console.error("Could not parse SmartFolio permission:", e);
  }

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {/* New invoice */}
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute
          exact
          path={
            isFolioV3Enabled || isSmartFolioEnabled
              ? "/folio/:bookingId?/:childFolioId?"
              : "/folio/:bookingId"
          }
          component={() => {
            if (isFolioV3Enabled) {
              return <BlackAndWhiteFolio />;
            } else if (isSmartFolioEnabled) {
              return <Invoice selectedLanguage={selectedLanguage} />;
            } else {
              return <Folio selectedLanguage={selectedLanguage} />;
            }
          }}
        />
        {/* Shops - Revamped */}
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/viewOrders"
          component={ViewOrders}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/reports"
          component={Reports}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/1"
          component={AllRestaurantDayWiseReport}
        />
        <ContentRoute
          exact
          path="/stock/report/1"
          component={WarehouseStockReport}
        />
        <ContentRoute
          exact
          path="/stock/report/7"
          component={FoodCostingReport}
        />
        <ContentRoute
          exact
          path="/stock/report/2"
          component={KitchenStockReport}
        />
        <ContentRoute
          exact
          path="/stock/report/3"
          component={PurchaseOrderReport}
        />
        <ContentRoute
          exact
          path="/stock/report/4"
          component={ClosingStockWarehouseReport}
        />
        <ContentRoute
          exact
          path="/stock/report/5"
          component={ClosingStockKitchenReport}
        />
        <ContentRoute
          exact
          path="/stock/report/0"
          component={WarehouseCumulativeReport}
        />
        <ContentRoute
          exact
          path="/stock/report/6"
          component={WareHouseConsumptionReport}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/4"
          component={RestaurantDayWiseBalanceSummaryReoprt}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/2"
          component={HourlyItemSalesReport}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/3"
          component={CategorySummaryReport}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/5"
          component={OrderWiseSalesSummaryReport}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/6"
          component={KotModificationReport}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/7"
          component={KotReport}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/report/8"
          component={DaywiseItemSummaryReport}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/configureStaff"
          component={ConfigureStaff}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/placeOrder"
          component={PlaceOrderPage}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/tableOrder/:type/:tableId/:tableName/placeOrder"
          component={TableView}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/roomOrder/:type/:roomId/placeOrder"
          component={TableView}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/randomOrder/:type/:randomId/placeOrder"
          component={TableView}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/table"
          component={Table}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/invoice-config"
          component={InvoiceConfig}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/configureTable"
          component={ConfigureTable}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/:discountId/:discountName/editDiscount"
          component={EditDiscount}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/configureDiscount"
          component={ConfigureDiscount}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/discounts"
          component={Discount}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/:staffId/:staffName/editStaff"
          component={EditStaff}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/staff"
          component={Staff}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/:categoryId/:categoryName/editCategory"
          component={EditCategory}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/configureCategory"
          component={ConfigureCategory}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/categories"
          component={ProductCategories}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/:categoryId/:itemId/:itemName"
          component={EditItems}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/:categoryId/item"
          component={ConfigureItems}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/menu"
          component={MenuItems}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/outletConfiguration"
          component={OutletConfiguration}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/outlet"
          component={OutletPage}
        />
        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType/dashboard"
          component={ShopDashboard}
        />
        <ContentRoute
          exact
          path="/allOutlets/addOutlet"
          component={AddNewShop}
        />
        {/* <ContentRoute exact path="/allOutlets" component={AllShops} /> */}
        <ContentRoute exact path="/allOutlets" component={OutletDashboard} />
        <ContentRoute
          exact
          path="/space-dashboard/:rentalId/"
          component={SingleRentalSpaceDashboard}
        />
        <ContentRoute
          exact
          path="/space-report/:reportId/"
          component={ReportsDashboard}
        />

        <ContentRoute
          exact
          path="/outlet/:shopId/:shopName/:shopType"
          component={Shop}
        />

        {/* Folios */}
        <ContentRoute path="/folio/:bookingId" component={Folio} />
        {/* <ContentRoute path="/folio/:bookingId" component={BlackAndWhiteFolio} /> */}
        <ContentRoute
          path="/reports/folio"
          component={() => <FolioReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          path="/reports/archived-folio"
          component={() => (
            <ArchivedFolioReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute path="/propertyDetails" component={PropertyDetails} />

        {/* RoomFolio */}
        <ContentRoute path="/roomFolio/:resId" component={RoomFolio} />
        <ContentRoute
          path="/folios/AdvancedPortfolio"
          component={AdvancedPortfolioWrapper}
        />
        <ContentRoute
          path="/shops/startOrder/cartInvoice"
          component={CartInvoice}
        />
        <ContentRoute
          path="/houseKeeping"
          component={() => <HouseKeeping selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          path="/shops/:shopId/viewOrders"
          component={POSViewOrders}
        />
        <ContentRoute
          path="/shops/:shopId/startOrder/order/:orderId"
          component={CreatedOrder}
        />
        <ContentRoute path="/shops/:shopId/startOrder" component={StartOrder} />
        <ContentRoute
          path="/shops/:shopId/shopConfiguration"
          component={ShopConfiguration}
        />
        <ContentRoute
          path="/shops/addShop-addDetails"
          component={AddNewShopAdditionalDetails}
        />
        <ContentRoute path="/shops" component={Shops} />

        <ContentRoute
          path="/reports/flash-manager"
          component={() => (
            <FlashManagerReport selectedLanguage={selectedLanguage} />
          )}
          // component={FlashManagerReport}
        />
        <ContentRoute
          path="/reports/night-audit"
          component={() => <AuditReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          path="/inventory-calendar"
          component={InventoryCalendar}
        />
        <ContentRoute path="/enquiry-page" component={IshaEnquiryPage} />
        <ContentRoute path="/refund-page" component={IshaRefundPage} />
        <ContentRoute path="/posDetailReport" component={POSDetailReport} />
        <ContentRoute path="/posReport" component={POSReport} />
        <ContentRoute path="/travelAgentReport" component={TravelAgentReport} />
        <ContentRoute path="/flexCollectReport" component={FlexCollectReport} />
        <ContentRoute
          exact
          path="/reports/cm-bookings"
          component={() => (
            <ChannelManagerReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/customers"
          component={() => (
            <CustomerReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/expense"
          component={() => (
            <ExpenseReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/tally"
          component={() => (
            <TallyLogsReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/space-reports"
          component={() => <AgridRentals selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          path="/reports/be-bookings"
          component={() => (
            <BookingEngineReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/occupancy"
          component={() => (
            <OccupancyReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/room-taxes"
          component={() => <TaxReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          path="/reports/gst"
          component={() => <GSTReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          path="/reports/room-revenue"
          component={() => (
            <RoomRevenueReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/isha-preview-e-receipt"
          component={IshaEreceiptPreview}
        />
        <ContentRoute
          path="/reports/room-revenue-src"
          component={() => (
            <RoomRevenueReportSource selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/inventory"
          component={() => (
            <InventoryReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/service"
          component={() => (
            <ServicesReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/counter"
          component={() => (
            <CounterReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/payment-gateway"
          component={() => (
            <PaymentsReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/sales"
          component={() => <SalesReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          exact
          path="/reports/master"
          component={() => <AgGridTable selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          exact
          path="/reports/day-use"
          component={() => <DayUseReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          exact
          path="/reports/room-booking"
          component={() => (
            <RoomBookingReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/arrivals"
          component={() => (
            <ArrivalsReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/departures"
          component={() => (
            <DepartureReports selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/in-house"
          component={() => (
            <InhouseReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/on-hold"
          component={() => <OnholdReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          exact
          path="/reports/all-outlets-day-sales-summary"
          component={() => (
            <DaywiseAllOutletSales selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/all-outlets-hourly-items-sales"
          component={() => (
            <AllOutletsHourlyItemsSalesSummary
              selectedLanguage={selectedLanguage}
            />
          )}
        />
        <ContentRoute
          exact
          path="/reports/all-outlets-item-category-summary"
          component={() => (
            <AllOutletsItemWiseCategory selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/all-outlets-orders-sales-summary"
          component={() => (
            <AllOutletsOrderSales selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/booking-notes"
          component={() => (
            <BookingNotesReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/customer-notes"
          component={() => (
            <CustomerNotesReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/shopwise-rev"
          component={() => (
            <ShopwiseRevReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/self-checkin"
          component={() => (
            <SelfCheckinReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/room-upgrade"
          component={() => (
            <RoomUpgradeReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/early-cin"
          component={() => (
            <EarlyCheckinReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/late-cout"
          component={() => (
            <LateCheckoutReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/dnr-list"
          component={() => (
            <DoNotRentReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/room-revenue-ota"
          component={() => (
            <RoomRevByOTAReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/refunds"
          component={() => (
            <RefundsReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/transfers"
          component={() => (
            <TransfersReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/payments-type-report"
          component={() => (
            <PaymentsReportByPaymentType selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/payments-user-report"
          component={() => (
            <PaymentsUserReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/counter-type-report"
          component={() => (
            <CounterReportByPaymentType selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/payments-type-report"
          component={() => (
            <PaymentsReportByPaymentType selectedLanguage={selectedLanguage} />
          )}
        />
        {/* <ContentRoute
          exact
          path="/reports/payments-user-report"
          component={PaymentsUserReport}
        /> */}
        <ContentRoute
          exact
          path="/reports/service-sales"
          component={() => (
            <ServiceSalesReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/db-ar-balance-report"
          component={() => (
            <DirectBillingARBalanceReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/db-ar-aging-report"
          component={() => (
            <DirectBillingArAgingReport selectedLanguage={selectedLanguage} />
          )}
        />

        <ContentRoute
          path="/reports/custom"
          component={() => (
            <CustomizedReport selectedLanguage={selectedLanguage} />
          )}
        />
        {/* <ContentRoute path="/reports" component={Report} /> */}
        <ContentRoute
          exact
          path="/reports"
          component={() => (
            <ReportWrapper selectedLanguage={selectedLanguage} />
          )}
          // component={ReportWrapper}
        />
        <ContentRoute
          path="/calendar"
          component={() => <Calendar selectedLanguage={selectedLanguage} />}
        />

        <ContentRoute path="/channelMapping" component={ChannelMapping} />
        <ContentRoute path="/propertyDetails" component={PropertyDetails} />
        <ContentRoute
          path="/folios/AdvancedPortfolio"
          component={AdvancedPortfolioWrapper}
        />
        <ContentRoute
          path="/shops/startOrder/cartInvoice"
          component={CartInvoice}
        />
        <ContentRoute
          path="/houseKeeping"
          component={() => <HouseKeeping selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute path="/shops/:shopId/startOrder" component={StartOrder} />
        <ContentRoute
          path="/shops/shopConfiguration"
          component={ShopConfiguration}
        />
        <ContentRoute
          path="/shops/addShop-addDetails"
          component={AddNewShopAdditionalDetails}
        />
        <ContentRoute path="/shops" component={Shops} />
        <ContentRoute
          path="/inventory-calendar"
          component={() => (
            <InventoryCalendar selectedLanguage={selectedLanguage} />
          )}
          // component={InventoryCalendar}
        />
        <ContentRoute path="/posDetailReport" component={POSDetailReport} />
        <ContentRoute path="/posReport" component={POSReport} />
        <ContentRoute path="/travelAgentReport" component={TravelAgentReport} />
        <ContentRoute path="/flexCollectReport" component={FlexCollectReport} />
        <ContentRoute path="/customers" component={CustomerReport} />
        <ContentRoute
          path="/reports/new-bookings"
          component={() => (
            <NewBookingsReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/no-show"
          component={() => <NoShowReport selectedLanguage={selectedLanguage} />}
        />

        {/* <ContentRoute path="/taxReport" component={TaxReport} /> */}
        <ContentRoute
          path="/roomRevenueReport"
          component={() => (
            <RoomRevenueReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/inventory"
          component={() => (
            <InventoryReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/customizedReport"
          component={() => (
            <CustomizedReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          exact
          path="/reports/user-log"
          component={() => (
            <UserLogsReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/shift"
          component={() => <ShiftReport selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute
          path="/roomcalendar"
          component={() => (
            <GroupTimeline selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/calendar"
          component={() => <Calendar selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute path="/account-settings" component={AccountSetting} />
        <ContentRoute path="/account-info" component={AccountInfo} />
        <ContentRoute path="/booking-dashboard" component={BookingDashboard} />
        <ContentRoute
          path="/property-dashboard"
          component={() => (
            <PropertyDashboard selectedLanguage={selectedLanguage} />
          )}
          // component={PropertyDashboard}
        />

        <ContentRoute
          path="/rental-space"
          component={() => (
            <RentalDashboard selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/rental-folio/:bookingId"
          component={() => <RentalFolio selectedLanguage={selectedLanguage} />}
        />
        <ContentRoute path="/directBilling" component={DirectBilling} />
        <ContentRoute
          path="/reports/bar-pricing"
          component={() => (
            <BarPricingReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/commission"
          component={() => (
            <CommissionReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/ota-payment-report"
          component={() => (
            <OTAPaymentReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/reports/meal-plan-count"
          component={() => (
            <MealPlanCountReport selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute
          path="/expense-dashboard"
          component={ExpenseManagerDashBoard}
        />

        <ContentRoute
          path="/reputation-dashboard"
          component={ReputationManagementDashBoard}
        />
        <ContentRoute
          path="/payment-configuration"
          component={PaymentsDashboard}
        />

        <ContentRoute path="/nightAudit" component={NightAuditDashboard} />
        <ContentRoute
          path="/recommendations"
          component={() => (
            <DashboardRecommendation selectedLanguage={selectedLanguage} />
          )}
        />
        <ContentRoute path="/reportScheduler" component={ReportSchedule} />
        <ContentRoute
          path="/revenue-dashboard"
          component={() => (
            <RevenueDashboard selectedLanguage={selectedLanguage} />
          )}
          // component={RevenueDashboard}
        />
        {/* Inventory & Stock Management */}
        <ContentRoute path="/stock/rms" component={RawMaterialSupplier} />
        <ContentRoute path="/stock/hkrms" component={HousekeepingRawMaterial} />
        <ContentRoute
          path="/stock/hkrecipe"
          component={AddHousekeepingMaterial}
        />

        <ContentRoute path="/stock/kc" component={KitchenConfig} />
        <ContentRoute path="/stock/wrm" component={WarehouseRawMaterial} />
        <ContentRoute path="/stock/krm" component={KitchenRawMaterial} />
        <ContentRoute path="/stock/cls" component={ClosingStock} />
        <ContentRoute path="/stock/rmw" component={RawMaterialWastage} />
        <ContentRoute path="/stock/pr" component={ProductRecipe} />
        <ContentRoute path="/stock/po" component={PurchaseOrder} />
        <ContentRoute path="/stock/reports" component={InventoryStockReport} />
        <ContentRoute
          path="/stock/stock-dashboard"
          component={StockDashboard}
        />
        <ContentRoute path="/groupBeConfig" component={GroupBeConfig} />
        <ContentRoute path="/inbox/:customerId?" component={Chat} />
        <Redirect
          from="*"
          to={{ pathname: "/dashboard", search: `?hotelId=${hotelId}` }}
        />
      </Switch>
    </Suspense>
  );
};

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(BasePage);
